/**
 * Competition context value + the World Cup default (specs/competitions-hub-client Slice 3).
 *
 * Kept separate from the provider module so route helpers and tests can import the
 * shape/default without pulling React context in.
 */

import { WORLD_CUP_COMPETITION_ID } from '../../worldcup/worldcup.constants';

/**
 * `worldcup` = the legacy reference experience at /app/worldcup (unchanged behavior).
 * `generic`  = the parameterized shell at /app/competition/[competitionId].
 */
export type CompetitionSurface = 'worldcup' | 'generic';

export interface CompetitionContextValue {
  competitionId: string;
  /** Route prefix for this competition's tab tree; never has a trailing slash. */
  basePath: string;
  surface: CompetitionSurface;
}

/** Base path of the World Cup experience — its routes are not id-parameterized. */
export const WORLD_CUP_BASE_PATH = '/app/worldcup';

/**
 * Fallback used when a component renders outside a provider (Storybook stories,
 * existing unit tests, globally-mounted overlays). Keeping the World Cup as the
 * default means a missed provider degrades to exactly today's behavior instead of
 * throwing — the core of the "WC stays bit-for-bit unchanged" guarantee.
 */
export const WORLD_CUP_COMPETITION_CONTEXT: CompetitionContextValue = Object.freeze({
  competitionId: WORLD_CUP_COMPETITION_ID,
  basePath: WORLD_CUP_BASE_PATH,
  surface: 'worldcup' as const,
});
